import axios from "~/plugins/axios";

const baseEndpoint = "/web_api/v1/hdn/";

export default {
  getDossiers(params) {
    return axios.get(`${baseEndpoint}dossiers`, { params })
        .then((response) => response.data);
  },
  processRecord(recordId) {
    return axios.post(`${baseEndpoint}records/process/${recordId}`)
        .then((response) => response.data);
  },
  sendInformationRequest(mortgageId) {
    return axios.post(`${baseEndpoint}information_request/${mortgageId}`)
        .then((response) => response.data);
  },
  getRecord(recordId) {
    return axios.get(`${baseEndpoint}records/${recordId}`)
        .then((response) => response.data);
  },
  getRecords(dossierId) {
    return axios.get(`${baseEndpoint}dossiers/${dossierId}/records`)
        .then((response) => response.data);
  }
};
